import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import TooltipWrapper from "../enhancers/TooltipWrapper";
import Icon from "./Icon";

type GridAvailabilityIconProps = {
  icon: string;
  message: string;
  id: string;
};

const GridAvailabilityIcon = ({
  icon,
  message,
  id
}: GridAvailabilityIconProps) => (
  <TooltipWrapper
    condition={message?.length}
    wrapper={(children: JSX.Element) => (
      <OverlayTrigger
        overlay={
          <Tooltip id={id} data-testid={id}>
            {message}
          </Tooltip>
        }
        placement="bottom"
      >
        <span>{children}</span>
      </OverlayTrigger>
    )}
  >
    <Icon name={icon} />
  </TooltipWrapper>
);

export default GridAvailabilityIcon;
